'use client';

/**
 * LegalLink — renders an `<a>` to a legal page; default left-click
 * opens the LegalModal in-page. Modifier-clicks (cmd/ctrl/shift) and
 * middle-clicks fall through to native nav so "Open in new tab" still
 * works. The `href` attribute is preserved for SEO and right-click
 * "Open link in new tab" affordances.
 *
 * Track 3.3 (2026-05-13).
 */

import { LEGAL_PAGES, type LegalSlug } from './LegalModal';
import { useLegalModal } from './LegalModalProvider';

interface LegalLinkProps {
  slug: LegalSlug;
  children: React.ReactNode;
  className?: string;
}

export function LegalLink({ slug, children, className }: LegalLinkProps) {
  const { open } = useLegalModal();
  const href = LEGAL_PAGES[slug].path;
  return (
    <a
      href={href}
      onClick={(e) => {
        // Let modifier + middle clicks fall through to native nav.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
        e.preventDefault();
        open(slug);
      }}
      className={className}
    >
      {children}
    </a>
  );
}
